import React, { useState, useEffect, Fragment } from "react";
import { Modal, v5 } from "@credijusto/minerals";
import Security from "./Security";
import logoBuro from "./assets/logo_buro.svg";
import logoIpab from "./assets/LogoIPAB.png";
import styles from "./SiteFooter.module.scss";
import dataFooter from "./data.json";

const LinkModal = ({ data, title }) => {
  const [showModal, setShowModal] = useState(false);
  const [btnPrimaryProps, setBtnPrimaryProps] = useState({});
  const [btnSecondaryProps, setBtnSecondaryProps] = useState({});

  const goBack = () => {
    //navigate(-1);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const btnOkProps = {};
    if (data.btnPrimaryText && data.btnPrimaryBehavior !== "none") {
      if (data.btnPrimaryBehavior === "link" && data.btnPrimaryLink) {
        btnOkProps.as = "a";
        btnOkProps.href = data.btnPrimaryLink;
      } else if (data.btnPrimaryBehavior === "closeModal") {
        btnOkProps.onClick = closeModal;
      }
      setBtnPrimaryProps(btnOkProps);
    }

    const btnCancelProps = {};
    if (data.btnSecondaryText && data.btnSecondaryBehavior !== "none") {
      if (data.btnSecondaryBehavior === "link" && data.btnSecondaryLink) {
        btnCancelProps.as = "a";
        btnCancelProps.href = data.btnSecondaryLink;
      } else if (data.btnSecondaryBehavior === "closeModal") {
        btnCancelProps.onClick = closeModal;
      } else if (data.btnSecondaryBehavior === "returnPreviousPage") {
        btnCancelProps.onClick = goBack;
      }
      setBtnSecondaryProps(btnCancelProps);
    }
  }, [data]);

  return (
    <Fragment>
      <Modal
        title={data.title}
        content={data.content}
        open={showModal}
        type={data.type}
        variant={data.variant}
        hideHeaderCloseButton={data.hideCloseIcon}
        closeOnClickBackdrop={data.closeOnBackdropClick}
        btnOkText={data.btnPrimaryText}
        btnOkProps={btnPrimaryProps}
        btnCancelText={data.btnSecondaryText}
        btnCancelProps={btnSecondaryProps}
      >
        {data.content}
      </Modal>
      <v5.Footer.Item
        key={`modal-link-${data.id || title}`}
        variant="body2"
        className={`${styles.modalLink}`}
        onClick={() => setShowModal(true)}
      >
        {title}
      </v5.Footer.Item>
    </Fragment>
  );
};

const LinksGroup = ({ data, idx }) => (
  <Fragment>
    {data.title && (
      <v5.Footer.Item
        key={`group-title-${data.id || idx}`}
        isTitle
        variant="h6"
        className={
          idx > 0 &&
          "border-t border-mn-background-tertiary pt-mn-300 mt-mn-300"
        }
      >
        {data.title}
      </v5.Footer.Item>
    )}
    {data.links
      .sort((a, b) => a.order - b.order)
      .map((l, linkIdx) => {
        const uniqueKey = l.id ? `link-${l.id}` : `link-${l.name}-${linkIdx}`;

        if (l.modal) {
          return <LinkModal key={uniqueKey} data={l.modal} title={l.name} />;
        }

        if (l.internal) {
          return (
            <v5.Footer.Item
              key={uniqueKey}
              variant="body2"
              as={"a"}
              href={`https://covalto.com${l.link}`}
              aria-labelledby={l.name}
            >
              {l.name}
            </v5.Footer.Item>
          );
        }
        return (
          <v5.Footer.Item
            key={uniqueKey}
            variant="body2"
            as="a"
            href={!!l.file ? l.file.localFile.url : l.link}
            download={!!l.file}
            aria-labelledby={l.name}
            target="_blank"
          >
            {l.name}
          </v5.Footer.Item>
        );
      })}
  </Fragment>
);

const Footer = ({
  legalText = null,
  legalTextAdditional = null,
  logosInstitutionEnabled = true,
  contentPanelEnabled = true,
}) => {
  return (
    <>
      <Security />
      <v5.Footer
        legalText={legalText || dataFooter.footerLegalText}
        institutionOne={{
          alt: "Buró de Entidades Financieras",
          logo: logoBuro,
          website: "https://covalto.com/buro-de-entidades-financieras/",
        }}
        institutionTwo={{
          alt: "Instituto para la Protección al Ahorro Bancario",
          logo: logoIpab,
          website: "https://covalto.com/productos-garantizados-por-el-ipab/",
        }}
        logoEnabled={false}
        legalTextAdditional={legalTextAdditional}
        logosInstitutionEnabled={logosInstitutionEnabled}
        contentPanelEnabled={contentPanelEnabled}
      >
        {dataFooter.footerLinks && dataFooter.footerLinks.length > 0 && (
          <v5.Footer.Column key="footer-column-1">
            {dataFooter.footerLinks
              .filter((x) => x.footer_column === 1)
              .map((link, idx) => (
                <LinksGroup
                  key={`footer-group-1-${link.id || idx}`}
                  data={link}
                  idx={idx}
                />
              ))}
          </v5.Footer.Column>
        )}
        <v5.Footer.Column key="footer-column-2">
          {dataFooter.footerLinks
            .filter((x) => x.footer_column === 2)
            .map((link, idx) => (
              <LinksGroup
                key={`footer-group-2-${link.id || idx}`}
                data={link}
                idx={idx}
              />
            ))}
        </v5.Footer.Column>
        <v5.Footer.Column key="footer-column-3">
          {dataFooter.footerLinks
            .filter((x) => x.footer_column === 3)
            .map((link, idx) => (
              <LinksGroup
                key={`footer-group-3-${link.id || idx}`}
                data={link}
                idx={idx}
              />
            ))}
          <v5.Footer.Item
            key="phone-switch"
            variant="body2"
            className="border-t border-mn-background-tertiary pt-mn-300 mt-mn-300 flex"
          >
            <span className="mr-mn-200">{dataFooter.phoneSwitchTitle}</span>
            <v5.Typography
              variant="body2"
              color="primary-dark"
              as="a"
              href={`tel:${dataFooter.phoneSwitch}`}
              className={`${styles.phone}`}
            >
              {dataFooter.phoneSwitch}
            </v5.Typography>
          </v5.Footer.Item>
          <v5.Footer.Item
            key="phone-item"
            variant="body2"
            className={`flex ${styles.phoneItem}`}
          >
            <span className="mr-mn-200">{dataFooter.phoneTitle}</span>
            <v5.Typography
              variant="body2"
              color="primary-dark"
              as="a"
              href={`tel:${dataFooter.phone}`}
              className={`${styles.phone}`}
            >
              {`${dataFooter.phone}`}
            </v5.Typography>
            {dataFooter.phoneCovalto && (
              <v5.Typography
                variant="body2"
                color="primary-dark"
                as="a"
                href={`tel:${dataFooter.phoneCovalto}`}
                className={`${styles.phone} pl-mn-200`}
              >
                {`/ ${dataFooter.phoneCovalto}`}
              </v5.Typography>
            )}
          </v5.Footer.Item>
          <v5.Footer.Item
            key="email-item"
            variant="body2"
            as="a"
            href="mailto:servicio@covalto.com"
            target="_blank"
          >
            servicio@covalto.com
          </v5.Footer.Item>
          <v5.Footer.Item
            key="address-item"
            variant="body2"
            className="mb-mn-200"
            as="a"
            href={dataFooter.address.urlGoogleMaps}
            target="_blank"
          >
            {`${dataFooter.address.street} ${dataFooter.address.outdoorNumber}, ${dataFooter.address.interiorNumber}, ${dataFooter.address.suburb}, C.P. ${dataFooter.address.postalCode}, ${dataFooter.address.city}, ${dataFooter.address.state}.`}
          </v5.Footer.Item>
          <v5.SocialNetwork
            key="social-network"
            mode="light"
            facebook="https://www.facebook.com/bancocovalto"
            linkedin="https://www.linkedin.com/company/bancocovalto"
            instagram="https://www.instagram.com/bancocovalto"
            twitter="https://twitter.com/bancocovalto"
          />
        </v5.Footer.Column>
      </v5.Footer>
    </>
  );
};

export default Footer;
